import { motion } from "framer-motion";
import { ArrowUpRight, Video, Film, Music, Image as ImageIcon } from "lucide-react";
import { useT } from "@/lib/i18n";

const SERVICE_META = [
  {
    id: "vhs",
    img: "https://images.unsplash.com/photo-1481137344492-d5a150a97f8b?fm=jpg&q=80&w=1600&auto=format&fit=crop",
    Icon: Video,
    span: "md:col-span-8 md:row-span-2",
  },
  {
    id: "audio",
    img: "https://images.unsplash.com/photo-1494232410401-ad00d5433cfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHx2aHMlMjBjYXNzZXR0ZSUyMHRhcGV8ZW58MHx8fHwxNzgxNDI0NTgxfDA&ixlib=rb-4.1.0&q=85",
    Icon: Music,
    span: "md:col-span-4",
  },
  {
    id: "film",
    img: "https://images.unsplash.com/photo-1497008323932-4f726e0f13f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHx2aWRlb2NhbWVyYSUyMHZpbnRhZ2V8ZW58MHx8fHwxNzgxNDI0NTgxfDA&ixlib=rb-4.1.0&q=85",
    Icon: Film,
    span: "md:col-span-4",
  },
  {
    id: "photos",
    img: "https://images.unsplash.com/photo-1722173205783-d602329f0743?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxvbGQlMjBmYW1pbHklMjBwaG90byUyMG1lbW9yeXxlbnwwfHx8fDE3ODE0MjQ1ODF8MA&ixlib=rb-4.1.0&q=85",
    Icon: ImageIcon,
    span: "md:col-span-8",
  },
];

export default function Services() {
  const t = useT();
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div className="max-w-2xl">
            <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] font-semibold mb-5">
              {t.services.eyebrow}
            </p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F5F5F0] leading-[1.05] tracking-tight">
              {t.services.titleA}
              <br />
              <span className="text-[#A3A3A3] italic font-normal">{t.services.titleB}</span>
            </h2>
          </div>
          <p className="text-[#A3A3A3] text-base md:text-lg max-w-sm leading-relaxed">
            {t.services.note}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 auto-rows-[260px] md:auto-rows-[260px]">
          {SERVICE_META.map((s, i) => {
            const copy = t.services.items[s.id];
            return (
              <motion.a
                key={s.id}
                href="#contact"
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className={`group relative overflow-hidden rounded-sm border border-[#2A2A2A] hover:border-[#D4AF37]/60 transition-colors ${s.span}`}
              >
                <img
                  src={s.img}
                  alt={copy.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/20" />
                <div className="relative h-full p-7 md:p-9 flex flex-col justify-between">
                  <s.Icon className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.4} />
                  <div>
                    <h3 className="font-serif-display text-2xl md:text-3xl text-[#F5F5F0] leading-tight">
                      {copy.title}
                    </h3>
                    <p className="mt-3 text-sm md:text-base text-[#A3A3A3] max-w-md leading-relaxed">{copy.blurb}</p>
                    <div className="mt-5 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#F5F5F0] group-hover:text-[#D4AF37] transition">
                      {t.services.seePricing} <ArrowUpRight className="w-4 h-4" />
                    </div>
                  </div>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
